(function () {
  'use strict';

  if (window.__ffBackInStockInstalled) return;
  window.__ffBackInStockInstalled = true;

  var API_URL = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
  var API_REVISION = '2026-07-15';
  var RETRY_DELAYS = [800, 1800];

  function wait(milliseconds) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, milliseconds);
    });
  }

  function getSelectedVariant(mount) {
    var root = mount.closest('.ff-fridge-pdp, .ff-fittings-pdp');
    if (!root) return null;

    var selected = root.querySelector('[data-ff-fitting-variant]:checked, .ff-fridge-pdp__pack input[name="id"]:checked');
    var variantInput = selected || root.querySelector('form[data-product-form] input[name="id"]');
    if (!variantInput || !variantInput.value) return null;

    var available;
    if (variantInput.dataset.available === 'true' || variantInput.dataset.available === 'false') {
      available = variantInput.dataset.available === 'true';
    } else {
      var addButton = root.querySelector('[data-ff-atb], .ff-fridge-pdp__atb');
      available = addButton ? !addButton.disabled : mount.dataset.available === 'true';
    }

    return {
      id: String(variantInput.value),
      available: available
    };
  }

  function resetMount(mount) {
    var form = mount.querySelector('[data-ff-back-in-stock-form]');
    var success = mount.querySelector('[data-ff-back-in-stock-success]');
    var status = mount.querySelector('[data-ff-back-in-stock-status]');
    var email = form ? form.querySelector('input[type="email"]') : null;

    mount.classList.remove('is-submitting', 'is-success');
    if (form) form.hidden = false;
    if (success) success.hidden = true;
    if (status) status.textContent = '';
    if (email) email.removeAttribute('aria-invalid');
    if (mount.dataset.defaultLabelledby) {
      mount.setAttribute('aria-labelledby', mount.dataset.defaultLabelledby);
    }
  }

  function syncMount(mount) {
    var selectedVariant = getSelectedVariant(mount);
    if (!selectedVariant) return;

    var changedVariant = mount.dataset.variantId !== selectedVariant.id;
    mount.dataset.variantId = selectedVariant.id;
    mount.dataset.available = selectedVariant.available ? 'true' : 'false';
    mount.hidden = selectedVariant.available;

    if (changedVariant) resetMount(mount);
  }

  function errorMessage(response, payload) {
    if (response.status === 400 || response.status === 422) {
      var detail = payload && payload.errors && payload.errors[0] && payload.errors[0].detail;
      if (detail && detail.toLowerCase().indexOf('email') !== -1) {
        return 'Please enter a valid email address.';
      }
    }
    if (response.status === 429) return 'Too many attempts. Please wait a moment and try again.';
    return 'We couldn’t save your alert. Please try again.';
  }

  function shouldRetry(status) {
    return status === 429 || status >= 500;
  }

  async function subscribe(companyId, variantId, email) {
    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    };

    var lastResponse;
    var lastPayload;

    for (var attempt = 0; attempt <= RETRY_DELAYS.length; attempt += 1) {
      try {
        var controller = new AbortController();
        var timeout = window.setTimeout(function () { controller.abort(); }, 10000);

        lastResponse = await fetch(API_URL + '?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          headers: {
            'Content-Type': 'application/json',
            revision: API_REVISION
          },
          body: JSON.stringify(payload),
          signal: controller.signal
        });
        window.clearTimeout(timeout);

        if (lastResponse.ok) return;

        try {
          lastPayload = await lastResponse.json();
        } catch (parseError) {
          lastPayload = null;
        }

        if (!shouldRetry(lastResponse.status) || attempt === RETRY_DELAYS.length) {
          var responseError = new Error(errorMessage(lastResponse, lastPayload));
          responseError.isUserFacing = true;
          throw responseError;
        }
      } catch (requestError) {
        window.clearTimeout(timeout);
        if (requestError.isUserFacing) throw requestError;
        if (attempt === RETRY_DELAYS.length) {
          throw new Error('We couldn’t connect. Check your connection and try again.');
        }
      }

      await wait(RETRY_DELAYS[attempt] + Math.floor(Math.random() * 250));
    }
  }

  function initialiseMount(mount) {
    if (mount.dataset.ffBackInStockReady === 'true') return;
    mount.dataset.ffBackInStockReady = 'true';

    var form = mount.querySelector('[data-ff-back-in-stock-form]');
    var email = form ? form.querySelector('input[type="email"]') : null;
    var trap = form ? form.querySelector('input[name="website"]') : null;
    var submit = form ? form.querySelector('button[type="submit"]') : null;
    var status = mount.querySelector('[data-ff-back-in-stock-status]');
    var success = mount.querySelector('[data-ff-back-in-stock-success]');
    var successTitle = mount.querySelector('[data-ff-back-in-stock-success-title]');

    if (!form || !email || !submit || !status || !success || !successTitle) return;

    mount.dataset.defaultLabelledby = mount.getAttribute('aria-labelledby') || '';

    syncMount(mount);

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      status.textContent = '';
      email.removeAttribute('aria-invalid');

      if (trap && trap.value) return;

      if (!email.validity.valid) {
        email.setAttribute('aria-invalid', 'true');
        status.textContent = 'Please enter a valid email address.';
        email.focus();
        return;
      }

      syncMount(mount);
      if (!mount.dataset.variantId || mount.dataset.available === 'true') {
        status.textContent = 'This item is now available to order.';
        return;
      }

      mount.classList.add('is-submitting');
      submit.disabled = true;
      email.disabled = true;

      try {
        await subscribe(mount.dataset.companyId, mount.dataset.variantId, email.value.trim());
        form.hidden = true;
        success.hidden = false;
        mount.classList.add('is-success');
        mount.setAttribute('aria-labelledby', successTitle.id);
        email.value = '';
        try {
          success.focus({ preventScroll: true });
        } catch (focusError) {
          success.focus();
        }
      } catch (requestError) {
        status.textContent = requestError.message || 'We couldn’t save your alert. Please try again.';
        if (status.textContent === 'Please enter a valid email address.') {
          email.setAttribute('aria-invalid', 'true');
        }
      } finally {
        mount.classList.remove('is-submitting');
        submit.disabled = false;
        email.disabled = false;
      }
    });

    email.addEventListener('input', function () {
      email.removeAttribute('aria-invalid');
      status.textContent = '';
    });

    var root = mount.closest('.ff-fridge-pdp, .ff-fittings-pdp');
    if (root) {
      root.addEventListener('change', function () {
        window.setTimeout(function () { syncMount(mount); }, 0);
      });

      var addButton = root.querySelector('[data-ff-atb], .ff-fridge-pdp__atb');
      if (addButton && window.MutationObserver) {
        new MutationObserver(function () { syncMount(mount); }).observe(addButton, {
          attributes: true,
          attributeFilter: ['disabled']
        });
      }
    }
  }

  function initialiseAll(scope) {
    (scope || document).querySelectorAll('[data-ff-back-in-stock]').forEach(initialiseMount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialiseAll(document); });
  } else {
    initialiseAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialiseAll(event.target);
  });
})();
